export default __webpack_public_path__ + "static/media/avatar_unicorn7.b17de580.mp3";